module.exports = __webpack_public_path__ + "static/media/alimentacao.ec5f8dac.svg";